import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ComandosService } from '../../../infrastructure/services/comandos.service';
import { Observable } from 'rxjs/Observable';
import { ItemGeneralListado } from '../../../helpers/components/itemClasses/itemListadoGeneral.class';

@Component({
  selector: 'sx-usuario-importacion-form',
  templateUrl: 'usuario.importacion.form.component.html'
})
export class UsuarioImportacionFormComponent implements OnInit {
  private SERVICIO = 'SrvUsuario';
  comandoSeleccionado: String = null;
  comandos: Observable<ItemGeneralListado[]>;
  errores = {
    comando: null,
  };

  constructor(private aRoute: ActivatedRoute,
              private comandosService: ComandosService,
              private router: Router) { }

  ngOnInit() {
    this.comandos = this.comandosService.getListadoComandosByCodServicioConTraduccion(this.SERVICIO);
  }

  seleccionarComando(comando: ItemGeneralListado) {
    this.comandoSeleccionado = comando.id;
  }

  validar() {
    let esValido = true;
    if (!this.comandoSeleccionado) {
      this.errores.comando = 'VALOR_REQUERIDO';
      esValido = false;
    }

    return esValido;
  }

  getFormData() {
    return {
      comando: <string>this.comandoSeleccionado,
    };
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/importacionMasiva/forms/usuario.importacion.form.component.ts